module.exports = __webpack_public_path__ + "static/img/th.5a8dea57.png";